module.exports = __webpack_public_path__ + "static/media/singing.3a062e14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/activities/singing.png
// module id = 1479
// module chunks = 31